export default "__VITE_ASSET__BUf8x1ka__"